/** Fields read for the Day Rounding tab, by `getDayRoundingSettings` and `setDayRoundingSettings`. */
export const DAY_ROUNDING_SETTINGS_QUERY = `
  toleranceHours
  toleranceMinutes
`;
